const TaskFormMultiField = React.memo(function TaskFormMultiField(props){
    const {
        formItem,
        value,
        showLabelAsPlaceholder,
        indexFromParent,
        itemKeys,
        onChange,
    } = props;

    const change = React.useCallback(index => val => {
        let newValue =  _.clone(value);
        newValue[index] = val;
        onChange(newValue);
    }, [onChange, value]);

    const add = React.useCallback(event => {
        event.preventDefault();
        let newValue =  _.clone(value);
        newValue.push(null);
        onChange(newValue);
    }, [onChange, value]);

    const remove = React.useCallback(index => event => {
        event.preventDefault();
        let newValue =  _.clone(value);
        newValue.splice(index, 1);
        onChange(newValue);
    }, [onChange, value]);

    const isMulti = _.get(formItem, 'ProcessFormItem.is_multi', false);
    const multiMin = _.get(formItem, 'ProcessFormItem.multi_min', null);
    const multiMax = _.get(formItem, 'ProcessFormItem.multi_max', null);
    let children = [];

    _.each(value, (val, index) => {
        let buttons = [];
        let isLast = index === _.size(value) - 1;

        if (_.size(value) > 1 && (!multiMin || _.size(value) > multiMin)) {
            buttons.push(
                <button key={'btn-remove'} className={'remove-button'} onClick={remove(index)}>
                    <i className={'fa fa-minus-circle'} aria-hidden={'true'}/>
                </button>
            );
        }

        if (isLast && isMulti && (!multiMax || _.size(value) < multiMax)) {
            buttons.push(
                <button key={'btn-add'} className={'add-button'} onClick={add}>
                    <i className={'fa fa-plus-circle'} aria-hidden={'true'}/>
                </button>
            );
        }

        children.push(
            <TaskFormField
                key={itemKeys[index]}
                value={val}
                formItem={formItem}
                buttons={buttons}
                onChange={change(index)}
                showLabelAsPlaceholder={showLabelAsPlaceholder}
                indexFromParent={indexFromParent}
            />
        );
    });

    //useRenderDebug(`TaskFormMultiField|${_.get(formItem, 'ProcessFormItem.name', 'unknown')}`, {props, change, add, remove});

    return (
        <div className="react-task-form-multi-field flex-vertical">
            {children}
        </div>
    );
});

TaskFormMultiField.propTypes = {
    formItem: PropTypes.object,
    value: PropTypes.any,
    showLabelAsPlaceholder: PropTypes.bool,
    indexFromParent: PropTypes.number,
    itemKeys: PropTypes.array,
    onChange: PropTypes.func,
};

TaskFormMultiField.defaultProps = {
    formItem: null,
    value: [],
    showLabelAsPlaceholder: false,
    indexFromParent: null,
    itemKeys: [0],
    onChange: (name, value) => {},
};

TaskFormMultiField.displayName = 'TaskFormMultiField';